import { FETCH_TYPED_SPLITS, FETCH_TYPED_SPLITS_SUCCESS, FETCH_TYPED_SPLITS_FAIL } from 'actions/ActionTypes.js';

const INITIAL_STATE = {};

const fetchTypedSplitsSuccess = (state, action) => {
    return {
        ...state,
        [action.typedSplits.activityId]: {
            ...action.typedSplits,
            ...state.typedSplits
        }
    };
};

const fetchTypedSplitsFail = (state, action) => {
    return {
        ...state,
        ...action
    };
};

const handlers = {
    [FETCH_TYPED_SPLITS_SUCCESS]: fetchTypedSplitsSuccess,
    [FETCH_TYPED_SPLITS_FAIL]: fetchTypedSplitsFail
};

export default function activityPolyline(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchTypedSplits(activityId) {
    return {
        type: FETCH_TYPED_SPLITS,
        activityId: activityId
    };
}

// Getters
export const getTypedSplits = (state, activityId) => {
    return state.typedSplits[activityId] && state.typedSplits[activityId].splits;
};
